import { Outlet } from 'react-router'
import { SettingsContainer } from '../../../next/components/container-settings'

export default function () {
  return (
    <SettingsContainer>
      <Outlet />
    </SettingsContainer>
  )
}
